var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "icon-container",
    class: {
      'disabled': _vm.disabled,
      'loading': _vm.loading,
      'unfollowed': _vm.unfollowed && !_vm.subscriptionName,
      'unfollowed-person': _vm.unfollowed && _vm.subscriptionName
    }
  }, [_vm.subscriptionName && _vm.unfollowed ? _c('span', {
    staticClass: "subscriber-name"
  }, [_vm._v(" " + _vm._s(_vm.subscriptionLabel) + " ")]) : _c('cs-icon', {
    attrs: {
      "name": _vm.iconName,
      "color": _vm.colorImage,
      "container-size": "extra-medium"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }